<template>
  <v-card class="mt-8" flat color="transparent">
    <v-card-title class="primary--text font-weight-bold"
      >Resultados búsqueda</v-card-title
    >
    <v-card-subtitle
      >Basado en filtros aplicados en su búsqueda o área de visualización activa
      en el mapa</v-card-subtitle
    >

    <v-row class="pl-md-6 mb-10">
      <v-col cols="6" md="4" lg="3">
        <div class="d-flex primary--text">
          <SvgIcon
            icon="cp-outlined-diver-2"
            :height="imageHeight"
            fill="#004480"
          ></SvgIcon>
          <div class="pl-4 d-flex flex-column justify-center">
            <p class="ma-0 display-1 font-weight-bold">
              {{ event.dives || 0 }}
            </p>
            <p class="ma-0 body-1">buceos</p>
            <p class="ma-0 body-1">encontrados</p>
          </div>
        </div>
      </v-col>
      <v-col cols="6" md="4" lg="3">
        <div class="d-flex primary--text">
          <SvgIcon
            icon="cp-outlined-fish-1"
            :height="imageHeight"
            fill="#004480"
          ></SvgIcon>
          <div class="pl-4 d-flex flex-column justify-center">
            <p class="ma-0 display-1 font-weight-bold">
              {{ event.quantityOrganism || 0 }}
            </p>
            <p class="ma-0 body-1">especies</p>
            <p class="ma-0 body-1">consideradas</p>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" lg="6">
        <apexchart
          type="bar"
          height="380"
          style="height:400px"
          :options="chartOptionsFrecuencyOccurence"
          :series="seriesFrecuencyOccurence"
        ></apexchart>
        <v-card-subtitle>
          <p class="body-2 font-weight-medium">
            <span class="font-weight-bold pr-2 primary--text">Figura 1.</span>
            <span
              >Frecuencia de ocurrencia por especie, representada en porcentaje
              respecto al total de buceos considerados en su búsqueda. Categoría
              de abundancia corresponde a la moda registrada para los parámetros
              de búsqueda</span
            >
          </p>
        </v-card-subtitle>
      </v-col>
      <v-col cols="12" lg="6">
        <div id="chart" style="height:400px"></div>
        <v-card-subtitle>
          <p class="body-2 font-weight-medium">
            <span class="font-weight-bold pr-2 primary--text">Figura 2.</span>
            <span
              >Número de avistamientos por especie de acuerdo a sus parámetros
              de búsqueda</span
            >
          </p>
        </v-card-subtitle>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import SvgIcon from "../SvgIcon";

export default {
  components: { SvgIcon },
  props: ["event"],
  data: function() {
    return {
      _timerId: false,
      series: [],
      seriesLabels: [],
      abudancesApi: [],
      seriesFrecuencyOccurence: [
        { name: "Ocurrencias", data: this.event.occurrences || [0, 0] }
      ],
      chartOptionsFrecuencyOccurence: {
        chart: {
          type: "bar",
          height: 380
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            //distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom"
            }
          }
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#0087af",
            shadeTo: "light",
            shadeIntensity: 0.65
          }
        },
        dataLabels: {
          enabled: false,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
            fontSize: "16px"
          },
          formatter: function(val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex];
          },
          offsetX: -30,
          background: {
            enabled: true,
            foreColor: "#000",
            opacity: 0.6
          }
        },
        legend: {
          show: false
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        xaxis: {
          type: "category",
          labels: {
            style: {
              fontSize: "12px",
              cssClass: "scientificName"
            }
          }
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              fontSize: "15px",
              cssClass: "scientificName"
            },
            offsetX: 10,
            formatter: val => {
              return val[0];
            }
          }
        },
        title: {
          text: "Frecuencia de ocurrencia",
          align: "left",
          style: {
            fontSize: "17px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#0487af"
          }
        },
        tooltip: {
          theme: "dark",
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div class="div-tooltip">' +
              '<div class="tooltip-title">' +
              w.globals.labels[dataPointIndex][0] +
              "</div>" +
              '<div class="text-tooltip">' +
              "<span> Ocurrencia: " +
              series[seriesIndex][dataPointIndex].toFixed(1) +
              "%" +
              "</span><br>" +
              "<span> Abundancia: " +
              w.globals.labels[dataPointIndex][1] +
              "</span>" +
              "</div>"
            );
          },
          x: {
            show: true
          },
          y: {
            formatter: function(val, opt) {
              return parseFloat(val).toFixed(2) + "%";
            },
            title: {
              formatter: function() {
                return "";
              }
            }
          }
        }
      }
    };
  },
  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "40px";
        default:
          return "140px";
      }
    }
  },
  watch: {
    event: {
      deep: true,
      handler() {
        clearTimeout(this._timerId);
        this._timerId = setTimeout(() => {
          this.printGraphPie();
          this.getData();
        }, 0);
      }
    }
  },
  methods: {
    async getData() {
      this.abudancesApi = this.event.abundances;
      this.seriesFrecuencyOccurence = [
        { name: "Ocurrencias", data: this.event.occurrences || [0, 0] }
      ];
    },
    async printGraphPie() {
      this.series = [];
      this.seriesLabels = [];

      this.event.occurrencesPie.forEach(e => {
        this.series.push(e[1]);
        this.seriesLabels.push(e[0]);
      });
      this.options = {
        legend: {
          show: true,
          horizontalAlign: "center",
          floating: false,
          offsetY: 40,
          offsetX: -20,
          fontSize: "15px"
        },
        responsive: [
          {
            breakpoint: 900,
            options: {
              plotOptions: {
                offsetX: 100
              },
              legend: {
                show: false
              }
            }
          }
        ],
        series: this.series,
        chart: {
          height: 380,
          type: "pie",
          toolbar: {
            show: true,
            tools: {
              download: true
            }
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ",",
              headerCategory: "category",
              headerValue: "value"
            }
          }
        },
        title: {
          text: "Registros",
          align: "left",
          style: {
            fontSize: "17px",
            fontWeight: "bold",
            fontFamily: undefined,
            color: "#0487af"
          }
        },
        plotOptions: {
          pie: {
            dataLabels: {
              offset: 0
            }
          }
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#0087af",
            shadeTo: "light",
            shadeIntensity: 0.65
          }
        },
        dataLabels: {
          formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [val.toFixed(1) + "%"];
          }
        },
        labels: this.seriesLabels
      };
      let chart = new ApexCharts(
        document.querySelector("#chart"),
        this.options
      );
      chart.render();
      chart.resetSeries();
    }
  },
  mounted: function() {
    this.getData();
  }
};
</script>
<style>
.scientificName {
  font-style: italic;
  color: #004480 !important;
}

.scientificName tspan {
  color: #004480 !important;
}

.div-tooltip {
  border-radius: 5px;
  box-shadow: 2px 2px 6px -4px #999;
  font-size: 12px;
  left: 62px;
  opacity: 0.8;
  top: 20px;
  overflow: hidden;
  white-space: nowrap;
  z-index: 12;
  transition: 0.15s ease all;
  color: #fff;
  background: rgba(30, 30, 30, 0.8);
}
.tooltip-title {
  padding: 6px;
  font-size: 15px;
  margin-bottom: 4px;
  background: rgba(0, 0, 0, 0.7);
  border-bottom: 1px solid #333;
  border: 1px solid rgba(0, 0, 0, 0.5);
  font-weight: 600;
  font-style: italic;
}
.text-tooltip {
  padding: 6px;
}
</style>
